// NOTE: components
import Skeleton from '../../components/ui/Skeleton'

// NOTE: mirrors the grid of the loaded page, three columns from lg up
const CARD_PLACEHOLDERS = ['first', 'second', 'third']

const CliniciansSkeleton = () => (
	<div role="status" aria-label="Loading clinicians">
		{/* Header */}
		<section className="bg-white">
			<div className="mx-auto w-full max-w-7xl px-5 pt-16 sm:px-8 md:pt-[88px]">
				<Skeleton className="mx-auto mb-3 h-4 w-[150px]" />
				<Skeleton className="mx-auto mb-3 h-[42px] w-[280px] sm:h-12 sm:w-[380px] md:h-16 md:w-[520px]" />

				<div className="mx-auto mb-14 mt-5 max-w-[520px] md:mb-[72px]">
					<Skeleton className="mb-2.5 h-5 w-full" />
					<Skeleton className="mx-auto h-5 w-3/4" />
				</div>
			</div>
		</section>

		{/* Clinicians */}
		<section className="bg-white">
			<div className="mx-auto w-full max-w-7xl px-5 pb-16 sm:px-8 md:pb-[88px]">
				<div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
					{CARD_PLACEHOLDERS.map((placeholder) => (
						<div
							key={placeholder}
							className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-lift"
						>
							<Skeleton className="aspect-square w-full rounded-none" />

							<div className="p-6">
								<Skeleton className="mb-3 h-4 w-[110px]" />
								<Skeleton className="mb-3 h-6 w-4/5" />
								<Skeleton className="mb-4 h-3 w-1/2" />

								<Skeleton className="mb-2.5 h-4 w-full" />
								<Skeleton className="mb-6 h-4 w-2/3" />

								<Skeleton className="mb-4 h-4 w-1/2" />
								<Skeleton className="ml-auto h-4 w-[110px]" />
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	</div>
)

export default CliniciansSkeleton
